import { isMetricsEnabled } from "./isMetricsEnabled"
import { UserTimingMetric } from "./userTimingMetricsList"

/**
 * Обертка над performance.mark() с автоматической проверкой включенности метрик.
 * @param metric - метрика для performance.mark()
 * @returns void
 */
export const perfomanceStartMark = (metric: UserTimingMetric): void => {
    try {
        if (isMetricsEnabled()) {
            performance.mark(metric.start)
        }
    } catch (e) {
        console.error("Error in start metric", e)
    }
}

/**
 * Обертка над performance.mark() с автоматической проверкой включенности метрик.
 * @param metric - метрика для performance.mark()
 * @returns void
 */
export const perfomanceFinishMark = (metric: UserTimingMetric): void => {
    try {
        if (isMetricsEnabled()) {
            performance.mark(metric.finish)
            performance.measure(metric.name, metric.start, metric.finish)
        }
    } catch (e) {
        console.error("Error in finish metric", e)
    }
}
